var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdown = function SvgDropdown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2C20.1046 2 21 2.89543 21 4V6C21 7.10457 20.1046 8 19 8L5 8C3.89543 8 3 7.10457 3 6L3 4C3 2.89543 3.89543 2 5 2L19 2ZM19 6V4L5 4V6L19 6Z",
    fill: "#707577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16C20.1046 16 21 16.8954 21 18V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20L3 18C3 16.8954 3.89543 16 5 16L19 16ZM19 20V18H5V20H19Z",
    fill: "#707577"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C20.1046 9 21 9.89543 21 11V13C21 14.1046 20.1046 15 19 15L5 15C3.89543 15 3 14.1046 3 13L3 11C3 9.89543 3.89543 9 5 9L19 9ZM19 13V11L5 11V13L19 13Z",
    fill: "#707577"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dropdown.89698232c390ac9214bd966a76c5c1bf.svg";